// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__M7T4S","label":"styles_label__Tc0zA","icon":"styles_icon__n5WH0","selected":"styles_selected__pHZSp"};